import { Box, Divider } from '@mui/material'
import * as React from 'react'

function AnimalFooter({
  selectionModel,
  filteredAnimals,
}: {
  selectionModel: any
  filteredAnimals: any[]
}) {
  return (
    <Box sx={{ p: 1, display: 'flex' }}>
      <Divider />
      {`${selectionModel.length} selected / ${filteredAnimals.length} loaded`}
    </Box>
  )
}

export default AnimalFooter
